import { Calendar } from '@fullcalendar/core';
// import interactionPlugin from '@fullcalendar/interaction';
import iCalendarPlugin from '@fullcalendar/icalendar'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrap5Plugin from '@fullcalendar/bootstrap5'; 
import frLocale from '@fullcalendar/core/locales/fr';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // webpack uses file-loader to handle font files
import './main.css'; // our app's CSS

document.addEventListener('DOMContentLoaded', function() {
  var calendarEl = document.getElementById('calendar');

  var calendar = new Calendar(calendarEl, {
    plugins: [ iCalendarPlugin, dayGridPlugin, timeGridPlugin, listPlugin, bootstrap5Plugin ],
    themeSystem: 'bootstrap5',
    locale: frLocale,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth'
    },
    navLinks: true, // can click day/week names to navigate view
    dayMaxEvents: true,
    events: {
      url: 'https://cal.lesgrandsvoisins.com/radicale/mannchri/3973cca7-f3ed-b285-66d5-955387c23e40/',
      format: 'ics'
    },
    eventDataTransform: function (event) {
      if (!event.url) {
         event.url = "https://www.lesgrandsvoisins.com/forward/".concat(event.start.toString(),"-",event.end.toString());
      }
      return event;
    }
  });

  calendar.render();
});
